// DRKS Theme JS

document.addEventListener('DOMContentLoaded', function () {

  // Active nav link
  const currentPath = window.location.pathname;
  document.querySelectorAll('.nav-link').forEach(link => {
    if (link.getAttribute('href') === currentPath) {
      link.classList.add('active');
    }
  });

  // Filter buttons (non-link)
  document.querySelectorAll('.filter-btn:not(a)').forEach(btn => {
    btn.addEventListener('click', function () {
      this.closest('.filter-bar').querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
      this.classList.add('active');
    });
  });

  // Ajax add to cart
  document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const btn = form.querySelector('.btn-add');
      const originalText = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(new FormData(form))
      })
        .then(r => r.json())
        .then(() => {
          btn.textContent = '✓ Added!';
          setTimeout(() => {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 2000);
          // Update cart count
          return fetch('/cart.js');
        })
        .then(r => r.json())
        .then(cart => {
          const cartLinks = document.querySelectorAll('a[href="/cart"]');
          cartLinks.forEach(l => {
            l.textContent = `Cart (${cart.item_count})`;
          });
        })
        .catch(() => {
          btn.textContent = originalText;
          btn.disabled = false;
        });
    });
  });

});
